export default __webpack_public_path__ + "static/media/transmission_powerline_icon.e0c5e9b9.svg";